import { b as getKebabCaseLocale } from './formatDate-3c9d186b-20057f2b.js';

function getNumberFormatter(locale, options) {
  if (!Intl) {
    return undefined;
  }
  const kebabCaseLocale = (Array.isArray(locale) ? locale : [locale]).map(getKebabCaseLocale);
  try {
    return new Intl.NumberFormat(kebabCaseLocale, options);
  } catch (error) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#exceptions
    if (error instanceof RangeError) {
      if (options !== null && options !== void 0 && options.maximumFractionDigits || options !== null && options !== void 0 && options.minimumFractionDigits) {
        return getNumberFormatter(locale, {
          ...(options !== null && options !== void 0 ? options : {}),
          maximumFractionDigits: undefined,
          minimumFractionDigits: undefined
        });
      }
      // @TODO: handle RangeError
    }
    // @TOTO: handle TypeError
  }
  return new Intl.NumberFormat(kebabCaseLocale);
}
function getNumberFormat(getOptions) {
  return ({
    value,
    locale,
    ...restProps
  }) => {
    const numberFormat = getNumberFormatter(locale, typeof getOptions === 'function' ? getOptions(restProps) : getOptions);
    if (!numberFormat) {
      return `${value}`;
    }
    return numberFormat.format(value);
  };
}
/**
 * @param {number} value The value to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {number} maximumFractionDigits The maximum number of fraction digits to use.
 * @param {number} minimumFractionDigits The minimum number of fraction digits to use.
 */
const formatNumber = getNumberFormat(({
  maximumFractionDigits,
  minimumFractionDigits
}) => ({
  style: 'decimal',
  maximumFractionDigits,
  minimumFractionDigits
}));
var formatNumber$1 = formatNumber;

export { formatNumber$1 as f, getNumberFormat as g };
//# sourceMappingURL=formatNumber-c04a5a2d-5a59bc0a.js.map
